import React, { useEffect, useState } from "react";
import { Box, Portal } from "@mui/material";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks/store.hooks";

import { verifyAuthUser } from "../../store/models/auth/auth.thunk";
import { GameSelector } from "./game.selector";
import { GameFrame } from "../../components/Game/Frame/frame";
import "./game.css";
import { updateLoyalty } from "../../store/models/loyalty/loyalty.thunk";
import exit from "../../assets/icons/exit.svg";
import { exitGame } from "../../store/models/slots/slot.thunk";

export const Game = () => {
  const dispatch = useAppDispatch();
  const { url } = useOutletContext() as { url: string };
  const { userId, isDemo } = useAppSelector(GameSelector);
  const { game } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [icon, setIcon] = useState(false);
  const isMobile =
    "ontouchstart" in window ||
    //@ts-ignore
    (window.DocumentTouch && document instanceof window.DocumentTouch) ||
    navigator.maxTouchPoints > 0 ||
    //@ts-ignore
    window.navigator.msMaxTouchPoints > 0;
  // const backHandler = () => {
  //   setExit(true);
  //   setExitType("exit");
  // };
  // const depositHandler = () => {
  //   setExit(true);
  //   setExitType("deposit");
  // };
  // const registrationHandler = () => {
  //   setExit(true);
  //   setExitType("exit");
  //   navigate("/registration");
  // };
  // const handleCloseDialog = () => {
  //   setExit(false);
  // };
  // const handleGoBack = () => {
  //   if (exitType === "deposit") {
  //     navigate("/profile/payments/");
  //   } else {
  //     navigate("/");
  //   }
  // };
  useEffect(() => {
    return () => {
      dispatch(exitGame(game));
      dispatch(verifyAuthUser());
      dispatch(updateLoyalty({ user_id: userId }));
    };
  }, []);

  return (
    <>
      {isMobile ? (
        <MobileGame
          game_url={url}
          is_demo={isDemo}
          user_id={userId}
          icon={icon}
          setIcon={setIcon}
          is_mobile={isMobile}
        />
      ) : (
        <DesktopGame
          game_url={url}
          is_demo={isDemo}
          user_id={userId}
          icon={icon}
          setIcon={setIcon}
          is_mobile={isMobile}
        />
      )}
    </>
  );
};
type IGameProps = {
  game_url: string;
  is_demo: boolean;
  user_id: string;
  icon: boolean;
  setIcon: React.Dispatch<React.SetStateAction<boolean>>;
  is_mobile: boolean;
};

export const MobileGame = ({
  game_url,
  is_demo,
  icon,
  user_id,
  setIcon,
  is_mobile,
}: IGameProps) => {
  const navigate = useNavigate();
  // const ref = useRef<HTMLDivElement | null>(null);
  // useEffect(() => {
  //   if (ref.current) {
  //     alert(document.documentElement.offsetHeight - window.innerHeight);
  //     if (window.innerHeight < document.documentElement.offsetHeight) {
  //       ref.current.style.height = `calc(100vh - 1px - ${
  //         document.documentElement.offsetHeight - window.innerHeight
  //       }px)`;
  //     } else {
  //       ref.current.style.height = `calc(100vh - 80px)`;
  //     }
  //   }
  // }, []);
  return (
    <Box className="game__mobile">
      <Portal>
        <Box
          className="game__mobile-container"
          sx={{
            height: `calc(100vh - ${
              document.documentElement.offsetHeight - window.innerHeight
            }px)`,
          }}
        >
          <GameFrame
            game_url={game_url}
            is_demo={is_demo}
            user_id={user_id}
            setIcon={setIcon}
            is_mobile={is_mobile}
          />
          {icon && (
            <Box
              className="game__mobile-icon"
              onClick={() => {
                navigate(-1);
              }}
            >
              <img src={exit} alt="EXIT" />
            </Box>
          )}
        </Box>
      </Portal>
    </Box>
  );
};
export const DesktopGame = ({
  game_url,
  is_demo,
  user_id,
  setIcon,
  is_mobile,
}: IGameProps) => {
  return (
    <Box className="game__desktop">
      <Box className="game__desktop-container">
        <GameFrame
          game_url={game_url}
          is_demo={is_demo}
          user_id={user_id}
          setIcon={setIcon}
          is_mobile={is_mobile}
        />
      </Box>
    </Box>
  );
};
